import { render, staticRenderFns } from "./outstanding_bids_table.vue?vue&type=template&id=73b70550&"
import script from "./outstanding_bids_table.vue?vue&type=script&lang=js&"
export * from "./outstanding_bids_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports